import { getModuleState as getLayerModuleState } from "../../selectors";

export const IMAGERY_STATE_KEY = "IMAGERY_STATE";

export const getModuleState = (state) => getLayerModuleState(state)[IMAGERY_STATE_KEY];

export const getImageryLayerSummary = (state) => getModuleState(state).imageryLayerSummary;
